import $ from "jQuery";
// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper/modules'; // Added Autoplay and EffectFade
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);

// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules

function initSwiper() {
    console.log("initSwiper new 3");

    $(".slider-init").each(function(index, element) {
        console.log("loop through sliders 3");
        var slider_object = $(element);
        var slide_id = slider_object.parent().attr("id");
        var next = "#" + slide_id + " .swiper__next";
        var prev = "#" + slide_id + " .swiper__prev";
        var slidesPerView_mobile = slider_object.data('slidesperview_mobile');
        var slidesPerView_tablet = slider_object.data('slidesperview_tablet');
        var slidesPerView_desktop = slider_object.data('slidesperview_desktop');
        var scrollbar = slider_object.data('scrollbar');
        var scrollbar_mobile = slider_object.data('scrollbar_mobile');
        var space_mobile = slider_object.data('space_mobile');
        var space_desktop = slider_object.data('space_desktop');
        var slide_index = slider_object.data('slide_index');
        var slide_index_mobile = slider_object.data('slide_index_mobile');
        var animation_settings = slider_object.data('animation_settings');
        var animation_delay = slider_object.data('animation_delay');
        var animation_effect = slider_object.data('animation_effect');
        var animation_loop = slider_object.data('animation_loop');

        var slider = new Swiper(element, {
            slidesPerView: slidesPerView_mobile,
            spaceBetween: space_mobile,
            initialSlide: slide_index_mobile,
            effect: animation_effect, // Added fade effect
            loop: animation_loop,     // Enable looping

            speed: 500, // Set the transition time to 2000ms (2 seconds)
            fadeEffect: {
                crossFade: true // Smooth transition between slides
            },


            autoplay: {
                delay: 8000, // 6000ms delay between slides
                disableOnInteraction: false, // Continues autoplay after user interaction
            },

            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            breakpoints: {
                700: {
                    slidesPerView: slidesPerView_tablet,
                    spaceBetween: space_desktop,
                    initialSlide: slide_index_mobile,
                },
                1440: {
                    slidesPerView: slidesPerView_desktop,
                    spaceBetween: space_desktop,
                    initialSlide: slide_index,
                },
            },
            // Navigation arrows
            navigation: {
                nextEl: next,
                prevEl: prev,
            }
        });
    });
}

$(document).ready(function() {
    setTimeout(function(){
        initSwiper();
    }, 100);
});
